/* global $ */
import _ from 'lodash';


const console = window.console;
const Rails = window.Rails;
const CKEDITOR = window.CKEDITOR;

class AutosaveForm {

    constructor($form) {
        this.$form = $form;
        this.$submitButton = this.$form.find("[type=submit]");
        this.$lastUpdateTime = $(`body .last-update`);
        this.throttledSave = _.debounce(_.bind($form.submit, $form), 200);

    }

    init() {
        const that = this;
        let displayTimer = null;
        let ckeditorTimer = null;
        _.forOwn(CKEDITOR.instances, function (instance, _instanceName) {
            instance.on('change', function (e) {
                instance.updateElement();
                clearTimeout(ckeditorTimer);
                ckeditorTimer = setTimeout(() => that.throttledSave(), 200);
            });
        });

        this.$form
            .on("change keyup", function (e) {
                that.throttledSave();
            })
            .on("submit", function (e) {

                e.preventDefault();

                const formData = new FormData(that.$form[0]);

                $
                    .ajax({
                        dataType: "json",
                        url: that.$form.attr('action'),
                        method: that.$form.attr('method'),
                        data: formData,
                        contentType: false,
                        processData: false,
                        beforeSend: function () {
                            that.$lastUpdateTime.removeClass('error saved').addClass('displayed saving').text(I18n.t('js.auto_save.saving'));
                            clearTimeout(displayTimer);
                        }
                    })
                    .done(function (data, textStatus, jqXHR) {
                        that.$lastUpdateTime.removeClass('saving').addClass('saved').text(I18n.t('js.auto_save.saved')).attr('data-last-saved', moment().toISOString())
                        displayTimer = setTimeout(() => {
                            that.$lastUpdateTime.removeClass('saved displayed')
                        }, 5000)
                    })
                    .fail(function (jqXHR, _textStatus, errorThrown) {
                        if (jqXHR.status === 0) {
                            return;//The user probably moved before the callback arrived
                        }

                        if (jqXHR.status >= 400 && jqXHR.status <= 499) {
                            const data = JSON.parse(jqXHR.responseText);
                            that.$lastUpdateTime.removeClass('saving').addClass('error').text(I18n.t('js.auto_save.problem_when_saving'));
                            displayTimer = setTimeout(() => {
                                that.$lastUpdateTime.removeClass('error displayed')
                            }, 5000)
                        }

                    })
                    .always(function () {
                        Rails.enableElement(that.$submitButton[0]);
                    });


            });

    }
}

window.AutosaveForm = AutosaveForm;
